/**
 * Bundle lines arrive flat: every child carries its own SKU plus the parent's name, SKU
 * and image, and they share a parentId. Group them so the parent is shown once with its
 * SKUs underneath, while standalone lines stay as they are.
 */

/** A line belongs to a bundle only when it names a parent that isn't itself. */
const isBundleLine = (item) => {
  const parentSku = item?.parentProductSku;
  if (item?.parentId == null || !parentSku) {
    return false;
  }
  return parentSku !== item?.productSku;
};

/**
 * Bundle children share one cart id, so the id alone can't identify a row - the product
 * is what separates them.
 */
export const cartLineKey = (item) => `${item?.id}-${item?.productId}`;

export const groupCartByParent = (cartDetails) => {
  const rows = Array.isArray(cartDetails) ? cartDetails : [];
  const groups = [];
  const byParent = new Map();

  rows.forEach((item) => {
    if (!isBundleLine(item)) {
      groups.push({ key: `line-${cartLineKey(item)}`, parent: null, items: [item] });
      return;
    }

    const parentKey = `bundle-${item.parentId}-${item.parentProductSku}`;
    const existing = byParent.get(parentKey);
    if (existing) {
      existing.items.push(item);
      return;
    }

    const group = {
      key: parentKey,
      parent: {
        name: item.parentProName,
        sku: item.parentProductSku,
        // parentProductImage repeats the name on some rows; only the full path is usable.
        image: item.parentProductImageFullPath,
      },
      items: [item],
    };
    byParent.set(parentKey, group);
    groups.push(group);
  });

  return groups;
};
